import { type ParentComponent, Show } from "solid-js";
import Header from "./header/Header";
import Sidebar from "./sidebar/Sidebar";
import WelcomeModal from "../../../components/modal/WelcomeModal";
import NewPlatformTourModal from "../NewPlatformTourModal";
import { dismissWelcomeModal, showWelcomeModal } from "../../../state/welcomeModal";
import { useUserState } from "../../../state/user";

const Layout: ParentComponent = (props) => {
  const user = useUserState();

  return (
    <>
      <div class="flex h-screen min-w-desktop flex-col bg-surface-extra-subtle">
        <Header />

        <div class="flex grow overflow-hidden">
          <Sidebar />

          <main class="grow overflow-hidden rounded-tl-lg border-t border-l border-subtle bg-default px-8 pt-6">
            {props.children}
          </main>
        </div>
      </div>

      <WelcomeModal open={showWelcomeModal(user().id)} onDismiss={() => dismissWelcomeModal(user().id)} />

      {/* Yields to the 'welcome' modal to avoid stacking */}
      <Show when={!showWelcomeModal(user().id)}>
        <NewPlatformTourModal />
      </Show>
    </>
  );
};

export default Layout;
